import React, { useEffect, useRef, useState } from 'react';

export default function LivePriceBadge({ price }) {
  const timeoutRef = useRef(null);
  const prevPriceRef = useRef(null);
  const [flash, setFlash] = useState('');

  const numericPrice = Number(price);
  const hasPrice = Number.isFinite(numericPrice) && numericPrice > 0;

  useEffect(() => {
    if (!hasPrice) {
      prevPriceRef.current = null;
      setFlash('');
      return;
    }

    const previous = prevPriceRef.current;
    if (previous !== null && Math.abs(previous - numericPrice) > 1e-9) {
      setFlash(numericPrice > previous ? 'up' : 'down');
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setFlash('');
        timeoutRef.current = null;
      }, 550);
    }
    prevPriceRef.current = numericPrice;

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [hasPrice, numericPrice]);

  return (
    <span
      className={`live-price-badge${hasPrice ? '' : ' is-empty'}${flash ? ` flash-${flash}` : ''}`}
      title={hasPrice ? `Live ${numericPrice.toFixed(2)}` : 'Live price unavailable'}
    >
      {hasPrice ? numericPrice.toFixed(2) : '—'}
    </span>
  );
}
